import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchTenants } from '@/api/tenants/tenantsApi';
import type { TenantListItem } from '@/api/tenants/tenantsApi.types';
import type { PaginatedResult } from '@/api/pagination.types';
import { ADMIN_LIST_PAGE_SIZE } from '@/constants/adminPagination';
import { TENANTS_QUERY_KEY } from '@/constants/queryKeys';

export function useTenantsQuery(
  page: number,
  search: string
): UseQueryResult<PaginatedResult<TenantListItem>, Error> {
  return useQuery({
    queryKey: [...TENANTS_QUERY_KEY, page, search],
    queryFn: function loadTenants() {
      return fetchTenants(page, ADMIN_LIST_PAGE_SIZE, search);
    },
    placeholderData: keepPreviousData,
  });
}
